import { IHisInfoItemBehavior } from "./IHisInfoItemBehavior";
import { HisInformationItem } from "../..";
import { IHisInformationValue, HisInformationTextValue, HisInformationDateTimeValue } from "../../HisInformationValue";
import { EnterHospDateBehavior } from "./EnterHospDateBehavior";
import { LeaveHospDateBehavior } from "./LeaveHospDateBehavior";

export class EnterHospPeriodBehavior implements IHisInfoItemBehavior {
  private static readonly Key = "ENTER_HOSP_PERIOD";

  getValue(hisInfoItems: HisInformationItem[]): IHisInformationValue {
    const itemValues =  hisInfoItems.filter(x => x.name === EnterHospPeriodBehavior.Key).map(x => x.value);
    const enterHospDateBehavior = new EnterHospDateBehavior();
    const leaveHospDateBehavior = new LeaveHospDateBehavior();
    const enterHospDate = createDate(hisInfoItems, enterHospDateBehavior);
    const leaveHospDate = createDate(hisInfoItems, leaveHospDateBehavior);
    const values = (enterHospDate.length === leaveHospDate.length)
      ? enterHospDate.map((x, i) => formatEnterHospPeriod(x, leaveHospDate[i]))
      : [];
    const data = itemValues.length > 0 ? itemValues : values;
    return new HisInformationTextValue(EnterHospPeriodBehavior.Key, data);
  }
}

function createDate(items: HisInformationItem[], dateBehavior: IHisInfoItemBehavior): Date[] {
  const dateValue = dateBehavior.getValue(items);
  return (dateValue instanceof HisInformationDateTimeValue)
    ? dateValue.data
    : [];
}

/** 開始日時と終了日時の間の日数を返す。 */
function differenceDate(start: Date, end: Date): number {
  if (start > end) { throw new Error("argument error: 第1引数は第2引数と同日かそれ以前の日付でなければなりません。"); }

  const time = end.getTime() - start.getTime();
  const date = Math.floor(time / (1000 * 60 * 60 * 24));
  return date;
}

function formatEnterHospPeriod(enter: Date, leave: Date): string {
  const start = enter < leave ? enter : leave;
  const end = enter < leave ? leave : enter;

  const diffDate = differenceDate(start, end);
  const period = diffDate + 1;
  return period + "日";
}
